import React from "react";
import Typography from "@mui/material/Typography";
import { formatEmpty, formatCurrency } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function ProposedCostCell(cell) {
  const ratePerMileExists = nullCheck(cell, null, "row", "original", "proposedRpm");
  const miles = nullCheck(cell, null, "row", "original", "miles");
  let display = "";
  const value = formatEmpty(formatCurrency(cell.value, 2));

  if (ratePerMileExists && miles) {
    display = `Est. ${value}`;
  } else if (ratePerMileExists && !miles) {
    display = `${value}/mile`;
  } else {
    display = value;
  }

  return (
    <span style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          color: "black_solid.80",
        }}
      >
        {display}
      </Typography>
    </span>
  );
}
